import React, { useState } from "react";
import { Card, Button, Form, Nav } from "react-bootstrap";
import { BiLike, BiComment } from "react-icons/bi";

const reportComment = (id) => {
  alert(`Reported comment with ID: ${id}`);
  // Here you can implement an API call or logic to handle the report action
};

const ForumFeed = () => {


  const [posts, setPosts] = useState([
    {
      id: 1,
      company: "TechCorp",
      logo: "https://logo.clearbit.com/techcorp.com",
      date: "March 14, 2025",
      text: "Join the amazing Chris Dyer on April 30th, 5:00pm PST! Our guest is a true expert in the world of remote and hybrid work. He's a keynote speaker and a best-selling author. He'll be joining us to chat about so get ready to sharpen your communication skills and put on your serious faces (or not, we won't judge).Don't miss out on this opportunity to learn, laugh, and connect with like-minded folks. See you there!",
      likes: 15,
      comments: [
        { company: "Veritis", logo: "https://www.veritis.com/wp-content/themes/veritis/theme/img/logo.svg", text: "Looking forward to it!", time: "2h ago" },
        { company: "Wipro", logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTzwdw5LRRgFpiRRMi-TsjpT2KUPYL8lutKMQ&s", text: "Will there be a recording available?", time: "1h ago" },
        { company: "Infosys", logo: "https://static.vecteezy.com/system/resources/previews/020/336/451/non_2x/infosys-logo-infosys-icon-free-free-vector.jpg", text: "Can't wait! What time?", time: "30m ago" },
      ],
    },
    {
      id: 2,
      company: "Google",
      logo: "https://logo.clearbit.com/google.com",
      date: "March 12, 2025",
      text: "We're excited to announce the launch of our new AI-powered search features. Experience faster and more accurate search results with our latest update.",
      likes: 25,
      topic: "Announcement",
      comments: [
        { company: "Apple", logo: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg", text: "Great news! Congrats!", time: "3h ago" },
        { company: "Microsoft", logo: "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg", text: "Looking forward to trying it out!", time: "2h ago" },
        { company: "Amazon", logo: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg", text: "Amazing! Wishing you success!", time: "1h ago" },
      ],
    },
    {
      id: 3,
      company: "Microsoft",
      logo: "https://logo.clearbit.com/microsoft.com",
      date: "March 10, 2025",
      text: "Introducing our latest Azure updates! Join us for a webinar on March 25th to explore new cloud capabilities.",
      likes: 18,
      topic: "Event",
      comments: [
        { company: "Veritis", logo: "https://www.veritis.com/wp-content/themes/veritis/theme/img/logo.svg", text: "Excited for this!", time: "4h ago" },
        { company: "Wipro", logo: "https://upload.wikimedia.org/wikipedia/commons/8/80/Wipro_Logo.svg", text: "Will it cover AI integration?", time: "3h ago" },
        { company: "Infosys", logo: "https://upload.wikimedia.org/wikipedia/commons/9/95/Infosys_logo.svg", text: "Looking forward to the details!", time: "2h ago" },
      ],
    },
    {
      id: 4,
      company: "Amazon",
      logo: "https://logo.clearbit.com/amazon.com",
      date: "March 15, 2025",
      text: "AWS re:Invent 2025 dates announced! Mark your calendars for an exciting week of innovation and networking.",
      likes: 30,
      topic: "Event",
      comments: [
        { company: "Tech Mahindra", logo: "https://upload.wikimedia.org/wikipedia/commons/8/8e/Tech_Mahindra_Logo.svg", text: "Can't wait to attend!", time: "1h ago" },
        { company: "Google", logo: "https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg", text: "Great lineup expected!", time: "45m ago" },
        { company: "Apple", logo: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg", text: "See you there!", time: "30m ago" },
      ],
    },
    {
      id: 5,
      company: "Veritis",
      logo: "https://www.veritis.com/wp-content/themes/veritis/theme/img/logo.svg",
      date: "March 13, 2025",
      text: "Proud to announce our new partnership with a leading cloud provider. More details coming soon!",
      likes: 12,
      topic: "Announcement",
      comments: [
        { company: "Microsoft", logo: "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg", text: "Congrats on the partnership!", time: "5h ago" },
        { company: "Wipro", logo: "https://upload.wikimedia.org/wikipedia/commons/8/80/Wipro_Logo.svg", text: "Exciting news!", time: "4h ago" },
        { company: "Infosys", logo: "https://upload.wikimedia.org/wikipedia/commons/9/95/Infosys_logo.svg", text: "Looking forward to more info!", time: "3h ago" },
      ],
    },
    {
      id: 6,
      company: "Wipro",
      logo: "https://logo.clearbit.com/wipro.com",
      date: "March 11, 2025",
      text: "Join our upcoming webinar on AI-driven business solutions. Register now to secure your spot!",
      likes: 20,
      topic: "Event",
      comments: [
        { company: "Tech Mahindra", logo: "https://upload.wikimedia.org/wikipedia/commons/8/8e/Tech_Mahindra_Logo.svg", text: "Registered already!", time: "2h ago" },
        { company: "Amazon", logo: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg", text: "Sounds interesting!", time: "1h ago" },
        { company: "Google", logo: "https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg", text: "Will it be recorded?", time: "30m ago" },
      ],
    },
    {
      id: 7,
      company: "Infosys",
      logo: "https://logo.clearbit.com/infosys.com",
      date: "March 16, 2025",
      text: "We're thrilled to share that we've won the 'Best IT Services Provider' award for 2025!",
      likes: 28,
      topic: "Announcement",
      comments: [
        { company: "Apple", logo: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg", text: "Well deserved!", time: "3h ago" },
        { company: "Microsoft", logo: "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg", text: "Congratulations!", time: "2h ago" },
        { company: "Veritis", logo: "https://www.veritis.com/wp-content/themes/veritis/theme/img/logo.svg", text: "Great achievement!", time: "1h ago" },
      ],
    },
    {
      id: 8,
      company: "Tech Mahindra",
      logo: "https://logo.clearbit.com/techmahindra.com",
      date: "March 17, 2025",
      text: "Discussing the future of 5G at our next tech summit. Join us on April 10th!",
      likes: 22,
      topic: "Event",
      comments: [
        { company: "Wipro", logo: "https://upload.wikimedia.org/wikipedia/commons/8/80/Wipro_Logo.svg", text: "Excited for this topic!", time: "4h ago" },
        { company: "Infosys", logo: "https://upload.wikimedia.org/wikipedia/commons/9/95/Infosys_logo.svg", text: "Looking forward to insights!", time: "3h ago" },
        { company: "Amazon", logo: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg", text: "See you at the summit!", time: "2h ago" },
      ],
    },
  ]);

  const [newPost, setNewPost] = useState("");
  const [visibleComments, setVisibleComments] = useState({});
  const [selectedTopic, setSelectedTopic] = useState("");
  const [activeTab, setActiveTab] = useState("general");
  const [sortBy, setSortBy] = useState("New");

  const filteredPosts = posts
    .filter((post) =>
      activeTab === "general"
        ? selectedTopic
          ? post.topic === selectedTopic
          : true
        : post.company === "Veritis" // My Feed shows only Veritis posts
    )
    .sort((a, b) =>
      sortBy === "Top" ? b.likes - a.likes : new Date(b.date) - new Date(a.date)
    );

  const handlePost = () => {
    if (newPost.trim()) {
      setPosts([
        {
          id: Date.now(),
          company: "Veritis In",
          logo: "https://www.veritis.com/wp-content/themes/veritis/theme/img/logo.svg",
          date: "Just now",
          text: newPost,
          likes: 0,
          topic: selectedTopic, // Include selected topic in new posts
          comments: [],
        },
        ...posts,
      ]);
      setNewPost("");
    }
  };

  const handleLike = (postId) => {
    setPosts(posts.map((post) => (post.id === postId ? { ...post, likes: post.likes + 1 } : post)));
  };

  const handleComment = (postId, commentText) => {
    setPosts(
      posts.map((post) =>
        post.id === postId
          ? {
              ...post,
              comments: [
                ...post.comments,
                {
                  company: "Veritis Group",
                  logo: "https://media.licdn.com/dms/image/v2/C510BAQHna_dD9vpNKg/company-logo_200_200/company-logo_200_200/0/1630628710289/veritis_group_inc_logo?e=2147483647&v=beta&t=8UDgYse3wANLmwRZ5JUULSvEFt7tOwLR8mQjtHkiAc4",
                  text: commentText,
                  time: "Just now",
                },
              ],
            }
          : post
      )
    );
  };

  const toggleComments = (postId) => {
    setVisibleComments((prev) => ({ ...prev, [postId]: !prev[postId] }));
  };



  const handleReport = (postId: string) => {
    alert(`Post ${postId} has been reported.`);
    // You can replace this with an API call or state update
  };

  



  return (
    <>

    <section className="page-header no-header bg-skyblue py-2">
        <div className="container py-4 pb-2">
          <div className="row page-introduction">
            <div className="col-12">
              <div className="d-flex align-items-center justify-content-start">
                <div className="text-start">
                  <h3>Forum</h3>
                  <p>A Community of Ideas: Dive into the Discussion!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <div className="container forum-container js-pg-hg">

        {/* Tabs and Filters */}
        <div className="d-flex justify-content-between align-items-center mb-4">

        <Nav justify-content-start>
  <Button
    variant={activeTab === "general" ? "primary" : "outline-primary text-primary"}
    onClick={() => setActiveTab("general")}
    className="me-3"
  >
    General
  </Button>
  <Button
    variant={activeTab === "myfeed" ? "primary" : "outline-primary text-primary"}
    onClick={() => setActiveTab("myfeed")}
  >
    My Feed
  </Button>
</Nav>

          <div className="d-flex gap-3">
            <Form.Select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="border rounded-2 p-2"
              style={{ width: "180px" }}
            >
              <option value="New">Most Recent</option>
              <option value="Top">Most Popular</option>
            </Form.Select>


          </div>
        </div>

        {/* Post Feed */}
        {filteredPosts.length > 0 ? (
          filteredPosts.map((post) => (



            
<Card key={post.id} className="mb-4 shadow-sm border-0 rounded-3" style={{ background: "#fff" }}>
  <Card.Body className="p-0">
    {/* Company Info with Three Dots Menu */}
    <div className="d-flex border-bottom p-3 align-items-center justify-content-between">
      <div className="d-flex align-items-center">
        <img
          src={post.logo}
          alt={post.company}
          className="rounded-circle border p-1 me-3"
          width="40"
          height="40"
        />
        <div>
          <h6 className="fs-6 p-0 m-0 mb-1 fw-500 text-dark">{post.company}</h6>
          <p className="text-muted fw-500 small mb-0">{post.date}</p>
        </div>
      </div>

      {/* Three Dots Menu */}
      <div className="dropdown">
        <button
          className="btn border-0 p-0"
          type="button"
          id={`dropdownMenuButton-${post.id}`}
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i class='bx bx-dots-vertical'></i>
        </button>

<ul className="dropdown-menu dropdown-menu-end border-0" aria-labelledby={`dropdownMenuButton-${post.id}`}>
  <li>
    <button className="dropdown-item text-danger fw-medium p-2" onClick={() => handleReport(post.id)}>
      Report this post
    </button>
  </li>
</ul>


      </div>
    </div>

    <Card.Text className="px-4 py-3 fs-6 text-dark">{post.text}</Card.Text>

    {/* Like & Comment Actions */}
    <div className="d-flex bg-light border-top p-3 align-items-center mb-0">
      <Button
        variant="outline-primary"
        size="sm"
        className="rounded-2 btm-sm px-2 me-3 py-1 text-primary fw-medium"
        onClick={() => handleLike(post.id)}
      >
        <BiLike className="me-1" /> {post.likes} Likes
      </Button>
      <Button
        variant="outline-primary"
        size="sm"
        className="rounded-2 btm-sm px-2 py-1 text-primary fw-medium"
        onClick={() => toggleComments(post.id)}
      >
        <BiComment className="me-1" /> {post.comments.length} Comments
      </Button>
    </div>

    {/* Comments Section */}
    {visibleComments[post.id] && (
      <>
        <hr className="p-0 m-0 mb-2" />
        <CommentSection postId={post.id} comments={post.comments} handleComment={handleComment} />
      </>
    )}
  </Card.Body>
</Card>





          ))
        ) : (
          <p className="text-muted text-center">No posts available for this selection.</p>
        )}
      </div>
    </>
  );
};

const CommentSection = ({ postId, comments, handleComment }) => {
  const [comment, setComment] = useState("");

  const submitComment = () => {
    if (comment.trim()) {
      handleComment(postId, comment);
      setComment("");
    }
  };

  return (
<div>
  {comments.map((c, index) => (
    <div key={index} className="mb-3 mx-3 mt-3 p-3 border rounded-3 border-light">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <div className="d-flex align-items-center">
          <img
            src={c.logo}
            alt={c.company}
            className="rounded-circle border me-2"
            width="30"
            height="30"
          />
          <div>
            <h6 className="fs-6 p-0 m-0 mb-1 fw-500 text-dark">{c.company}</h6>
            <p className="text-muted fw-500 small mb-0">{c.time}</p>
          </div>
        </div>
        {/* Report flag button */}
        <button title="Report" className="btn btn-small sm, btn-link m-0"
          onClick={() => reportComment(c.id)}
        ><i class='bx bxs-flag-alt' ></i></button>
      </div>
      <p className="mb-0 small fw-500 text-dark">{c.text}</p>
    </div>
  ))}
  <div className="d-flex border-top p-3 align-items-center">
    <Form.Control
      type="text"
      placeholder="Write a comment..."
      value={comment}
      onChange={(e) => setComment(e.target.value)}
      className="border border-light rounded-2 p-3 me-2"
      style={{ background: "#fff", boxShadow: "none" }}
    />
    <Button
      variant="outline-primary"
      size="sm"
      className="rounded-2 px-4 py-3 text-primary fw-medium"
      onClick={submitComment}
    >
      Comment
    </Button>
  </div>
</div>
  );
};

export default ForumFeed;